import { InvalidCredentialsError, isError, emailField, stringField, createValidationSchema, runUnsafe, } from "@for-it/domain-lib";
import { UserEntity } from "../../entities/user.js";
export const login = {
    name: "login",
    description: "Login that validates user credentials and returns an access token.",
    type: "command",
    payloadSchema: createValidationSchema({
        email: emailField({
            required: true,
            message: "Debe ingresar un email",
        }),
        password: stringField({
            required: true,
            message: "Debe ingresar una contraseña",
        }),
    }),
    useCase: async ({ crypto, db }, { email, password }) => {
        const user = await db.findOne(UserEntity, {
            where: { email },
        });
        if (!user) {
            return new InvalidCredentialsError();
        }
        const passwordResult = await crypto.assertValidPassword(password, user.hashedPassword);
        if (isError(passwordResult)) {
            return new InvalidCredentialsError();
        }
        const accessToken = await runUnsafe(crypto.generateAccessJWT({
            id: user.id,
            permissions: [],
        }));
        const refreshToken = await runUnsafe(crypto.generateRefreshJWT(user.id));
        return {
            accessToken,
            refreshToken,
            // Admin DB users do not currently support the forced
            // password-change flow, so these are always falsy here.
            mustChangePassword: false,
            passwordResetToken: null,
            user: {
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                permissions: [],
                role: { id: "", name: "" },
            },
        };
    },
};
